import { useState } from "react";
import { formatAmount } from "../utils/formatAmount";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CostDetails = _ref => {
  let {
    attestationFee,
    estimatedGas = BigInt(0),
    isLoading
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const totalAmountFormatted = `${formatAmount(attestationFee + estimatedGas)} ETH`;
  const attestationFeeFormatted = `${formatAmount(attestationFee)} ETH`;
  const estimatedGasFormatted = `${formatAmount(estimatedGas)} ETH`;
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full flex flex-col font-mono text-sm",
    children: [/*#__PURE__*/_jsxs("button", {
      onClick: () => setIsOpen(!isOpen),
      className: "flex items-center justify-between w-full focus:outline-none",
      "aria-expanded": isOpen,
      "aria-controls": "cost-details-content",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex flex-wrap gap-2",
        children: [/*#__PURE__*/_jsx("span", {
          children: "Total Cost"
        }), isOpen ? /*#__PURE__*/_jsx(ChevronUpIcon, {
          className: "w-5 h-5"
        }) : /*#__PURE__*/_jsx(ChevronDownIcon, {
          className: "w-5 h-5"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: `transition-opacity duration-500 ${isLoading ? "opacity-50" : "opacity-100"}`,
        children: /*#__PURE__*/_jsx("span", {
          children: totalAmountFormatted
        })
      })]
    }), isOpen && /*#__PURE__*/_jsxs("div", {
      id: "cost-details-content",
      className: "mt-2 space-y-2",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex justify-between",
        children: [/*#__PURE__*/_jsx("span", {
          children: "Attest Fee"
        }), /*#__PURE__*/_jsx("div", {
          className: `transition-opacity duration-500 ${isLoading ? "opacity-50" : "opacity-100"}`,
          children: /*#__PURE__*/_jsx("span", {
            children: attestationFeeFormatted
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex justify-between",
        children: [/*#__PURE__*/_jsx("span", {
          children: "Estimated Gas"
        }), /*#__PURE__*/_jsx("div", {
          className: `transition-opacity duration-500 ${isLoading ? "opacity-50" : "opacity-100"}`,
          children: /*#__PURE__*/_jsx("span", {
            children: estimatedGasFormatted
          })
        })]
      })]
    })]
  });
};